import { useMutation } from 'react-query';
import { apiAuthService } from '@services/apiCpService.ts';
import { useAuthStore } from '@stores/auth.store.ts';

export const VerifyGoogleTokenMutationKey = 'verify-google-token';

interface VerifyGoogleTokenData {
  token: string;
}

export const useVerifyGoogleTokenMutation = () => {
  const { setIsLoggedIn, setAccessToken, setIsUserVerified } = useAuthStore();

  return useMutation(
    VerifyGoogleTokenMutationKey,
    async (data: VerifyGoogleTokenData) => apiAuthService.googleAuthenticationAuthGooglePost(data),
    {
      onSuccess: (_, { token }) => {
        setIsLoggedIn(true);
        setIsUserVerified(true);
        setAccessToken(token);
      },
      onError: () => {
        setIsLoggedIn(false);
        setIsUserVerified(true);
        setAccessToken(null);
      },
    },
  );
};
